import React from "react";
import { useEmailAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/EmailAccountProvider/useEmailAccount";
import { EmailAccountCard } from "../../../../components/EmailAccountCard";
import { DomainSection } from "../DomainSection";
import { HowItWorksSection } from "../HowItWorksSection";
import { EmailForwardingSetupSection } from "../EmailForwardingSetupSection";

export const EmailGeneralTab: React.FC = () => {
  const { emailAccount } = useEmailAccount();
  const hasClientEmail = !!emailAccount?.metadata?.client_email;

  return (
    <div className="mx-auto flex w-full max-w-300 flex-col gap-8 p-8 max-lg:gap-4 max-lg:p-4">
      <EmailAccountCard />
      {hasClientEmail ? <DomainSection /> : <EmailForwardingSetupSection />}
      <HowItWorksSection />
    </div>
  );
};
